import { render, staticRenderFns } from "./twoColumnYeekeeCard.vue?vue&type=template&id=2498834a&scoped=true"
import script from "./twoColumnYeekeeCard.vue?vue&type=script&lang=js"
export * from "./twoColumnYeekeeCard.vue?vue&type=script&lang=js"
import style0 from "./twoColumnYeekeeCard.vue?vue&type=style&index=0&id=2498834a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2498834a",
  null
  
)

export default component.exports